import { createEvent, restore } from 'effector';

import { PUBLIC_URL } from 'shared/config';

const serviceWorkerPath = `${window.location.origin}${PUBLIC_URL}service-worker.js`;

const setNeedUpdate = createEvent<boolean>();
export const $needUpdate = restore(setNeedUpdate, false);

export const connectUpdater = () =>
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(serviceWorkerPath)
      .then(function (registration) {
        let updating = false;

        // Function handler for the ServiceWorker updates.
        registration.onupdatefound = () => {
          const serviceWorker = registration.installing;
          if (serviceWorker == null) {
            return;
          }

          serviceWorker.onstatechange = () => {
            if (
              serviceWorker.state === 'installed' &&
              navigator.serviceWorker.controller &&
              registration &&
              registration.waiting
            ) {
              updating = true;
            }

            if (updating && serviceWorker.state === 'activated') {
              setNeedUpdate(true);
            }
          };
        };
      })
      .catch(function (err) {
        // eslint-disable-next-line no-console
        console.error('ServiceWorker registration fa3led:  ', err);
      });
  });
